import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_payment_method_item = _resolveComponent("payment-method-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Delete Payment Method",
    size: "xs",
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_async_btn, {
        label: "Delete",
        color: "negative",
        task: _ctx.task,
        onClick: _ctx.remove
      }, null, 8, ["task", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_q_list, { bordered: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_payment_method_item, { "payment-method": _ctx.paymentMethod }, null, 8, ["payment-method"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}